import { render, staticRenderFns } from "./ButtonWrapperElement.vue?vue&type=template&id=645bd360&"
import script from "./ButtonWrapperElement.vue?vue&type=script&lang=js&"
export * from "./ButtonWrapperElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports